import React from 'react';
import styled from 'styled-components';
import { CloseRounded } from '@mui/icons-material';
import './TagStyle.css';

const TagContainer = styled.div`
	position: relative;
	display: flex;
	margin: ${({ $margin }) => ($margin ? $margin : '5px 5px 0px 0px')};
	border-radius: 4px;
	background: ${({ $forAutoComplete }) =>
		$forAutoComplete ? 'rgba(0, 0, 0, 0.08)' : 'transparent'};
	padding: 6px;
`;

const Icon = styled.div`
	line-height: ${({ $textSize }) => ($textSize ? $textSize + 'px' : '14px')};
	font-size: ${({ $textSize }) => ($textSize ? $textSize + 'px' : '14px')};
	margin-left: 5px;
	color: white;
`;

const Text = styled.div`
	white-space: nowrap;
	line-height: ${({ $textSize }) => ($textSize ? $textSize + 'px' : '14px')};
	font-size: ${({ $textSize }) => ($textSize ? $textSize + 'px' : '14px')};
`;

const Tag = styled.div`
	position: relative;
	padding: 4px 8px;
	border-radius: 4px;
	font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
	display: flex;
	flex-direction: row;
	flex-flow: nowrap;
	align-items: center;
	background: ${({ $gradient, $isGradient }) =>
		$gradient && $gradient.includes('#')
			? $isGradient
				? `linear-gradient(to right, ${$gradient})`
				: `${$gradient}`
			: 'transparent'};
	color: ${({ $textColor }) => ($textColor && $textColor.includes('#') ? $textColor : 'black')};
	text-transform: ${({ $isTextCap }) => ($isTextCap ? 'uppercase' : 'none')};
`;

const RemoveIconWrapper = styled.div`
	border-radius: 50px;
	padding: 3px;
	display: flex;
	align-items: center;
	cursor: pointer;
	margin: 0 0 0 4px;
	background: rgba(0, 0, 0, 0.2);
	color: white;
`;

const TagComponent = ({
	tag,
	onDelete,
	showDeleteIcon = true,
	containerMargin = '5px 5px 0px 0px',
	forAutoComplete,
}) => {
	const { name, gradient, textColor, textSize, isTextCap } = tag;

	const isGradient = gradient.includes(',');

	return (
		<TagContainer $margin={containerMargin} $forAutoComplete={forAutoComplete}>
			<Tag
				$isGradient={isGradient}
				$gradient={gradient}
				$textColor={textColor}
				$isTextCap={isTextCap}
			>
				<Text $textSize={textSize}>{name}</Text>
				{tag && tag.modal && <Icon $textSize={textSize}>{tag.modal?.textIcon}</Icon>}
			</Tag>
			{showDeleteIcon && (
				<RemoveIconWrapper onClick={() => onDelete(tag)}>
					<CloseRounded fontSize="12px" />
				</RemoveIconWrapper>
			)}
		</TagContainer>
	);
};

export default TagComponent;
